import React from "react";
import GridLines from "@/components/site/GridLines";

export default function Applications() {
  return (
    <section className="rf-apps" id="applications" data-testid="applications">
      <GridLines />
      <div className="rf-apps__rule" />
      <div className="rf-wrap">
        <div className="rf-apps__grid">
          <div className="rf-apps__left">
            <div className="rf-apps__cells">
              <div className="rf-apps__cell rf-apps__cell--white">
                <h3 className="rf-cardTitle">Commercial &amp; office interiors</h3>
                <p className="rf-cardBody rf-cardBody--onLight">
                  Smarter partitions, cabins, panelling and workspaces.
                </p>
              </div>
              <div className="rf-apps__cell rf-apps__cell--green">
                <h3 className="rf-cardTitle rf-cardTitle--onGreen">Retail &amp; hospitality</h3>
                <p className="rf-cardBody rf-cardBody--onGreen">
                  Cleaner execution for stores, restaurants, hotels and experience-led spaces.
                </p>
              </div>
            </div>
            <picture className="rf-apps__img rf-apps__img--wide">
              <source media="(max-width: 1023px)" srcSet="/assets/m-app1.png" />
              <img src="/assets/d-app1.png" alt="Fibre cement board cladding detail" />
            </picture>
          </div>
          <div className="rf-apps__right">
            <picture className="rf-apps__img rf-apps__img--tall">
              <source media="(max-width: 1023px)" srcSet="/assets/m-app2.png" />
              <img src="/assets/d-app2.png" alt="Fibre cement board panelling" />
            </picture>
            <div className="rf-apps__cell rf-apps__cell--yellow">
              <h3 className="rf-cardTitle">Modular furniture &amp; panelling</h3>
              <p className="rf-cardBody rf-cardBody--onLight">
                Board solutions for functional and design-led built-ins.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
